import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

//import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

class Authentication extends Component {

	componentDidMount () {
		process.env.REACT_APP_RUNTIME === 'Production' 
			? window.location.href = 'https://login.percepthor.com/splash'
			: process.env.REACT_APP_RUNTIME === 'Test'
				? window.location.href = 'https://test.login.percepthor.com/splash'
				: window.location.href = 'http://localhost.com/splash'
	}

  render () {
		return (
      <div>
        <h1>Redirecting...</h1>
      </div>
    );
  }
  
}

Authentication.propTypes = {};

const mapStateToProps = state => ({});

export default compose(
  withRouter,
  connect (mapStateToProps, { }) 
)(Authentication);